import { ITravelBookingProgressBar } from '@shared/shared/interfaces/travel-booking-progress-bar.interfaces';
import * as fromTravelBookingActions from '../actions/travel-booking-progress-bar.actions';

export const initialState: ITravelBookingProgressBar = {
  is_booking_complete: false,
  is_car_hire_details_complete: false,
  is_car_hire_results_complete: false,
  is_car_hire_search_complete: false,
  is_flight_options_complete: false,
  is_flight_results_complete: false,
  is_flight_search_complete: false,
  is_hotel_details_complete: false,
  is_hotel_results_complete: false,
  is_hotel_room_complete: false,
  is_hotel_search_complete: false,
};
export function reducer(
  state = initialState,
  action: fromTravelBookingActions.TravelBookingBarAction
): ITravelBookingProgressBar {
  switch (action.type) {
    case fromTravelBookingActions.RESTORE_TRAVEL_BOOKING_BAR_SUCCESS:
    case fromTravelBookingActions.UPDATE_TRAVEL_BOOKING_BAR_SUCCESS:
      return {
        ...state,
        ...action.payload,
      };

    case fromTravelBookingActions.CLEAR_TRAVEL_BOOKING_BAR:
      return initialState;
    default:
      return state;
  }
}
